import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="text-2xl font-bold tracking-tighter uppercase mb-4" style={{fontFamily: 'Barlow Condensed, sans-serif'}}>
              <span className="text-white">NETEXEC</span>
              <span className="text-orange-500"> GLOBAL</span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Freight forwarding and customs clearance for South African importers and exporters.
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold text-white mb-4 uppercase tracking-wider text-sm">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services/freight-forwarding" className="text-slate-400 hover:text-orange-500 text-sm transition-colors">
                  Freight Forwarding
                </Link>
              </li>
              <li>
                <Link to="/services/customs-clearance" className="text-slate-400 hover:text-orange-500 text-sm transition-colors">
                  Customs Clearance
                </Link>
              </li>
              <li>
                <Link to="/services/air-freight" className="text-slate-400 hover:text-orange-500 text-sm transition-colors">
                  Air Freight
                </Link>
              </li>
              <li>
                <Link to="/services/ocean-freight" className="text-slate-400 hover:text-orange-500 text-sm transition-colors">
                  Ocean Freight
                </Link>
              </li>
              <li>
                <Link to="/services/import-solutions" className="text-slate-400 hover:text-orange-500 text-sm transition-colors">
                  Import Solutions
                </Link>
              </li>
              <li>
                <Link to="/services/export-solutions" className="text-slate-400 hover:text-orange-500 text-sm transition-colors">
                  Export Solutions
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-semibold text-white mb-4 uppercase tracking-wider text-sm">Company</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-slate-400 hover:text-orange-500 text-sm transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/trade-routes" className="text-slate-400 hover:text-orange-500 text-sm transition-colors">
                  Trade Routes
                </Link>
              </li>
              <li>
                <Link to="/industries" className="text-slate-400 hover:text-orange-500 text-sm transition-colors">
                  Industries
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-slate-400 hover:text-orange-500 text-sm transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-orange-500 text-sm transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-white mb-4 uppercase tracking-wider text-sm">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-slate-400 text-sm">
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <a href="tel:+27119801717" className="hover:text-orange-500 transition-colors">
                  +27 11 980 1717
                </a>
              </li>
              <li className="flex items-start gap-2 text-slate-400 text-sm">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <a href="mailto:admin@netexecglobal.co.za" className="hover:text-orange-500 transition-colors">
                  admin@netexecglobal.co.za
                </a>
              </li>
              <li className="flex items-start gap-2 text-slate-400 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>South Africa</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 text-center text-slate-400 text-sm">
          <p>&copy; {new Date().getFullYear()} NETEXEC GLOBAL. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;